import { getImperative, isEventHandler, isImparative, isRepeater, isNestedAttributes, isMultiStateBox, } from './helpers';
var observeRepeater = function (veloElement, getObservableParams, opts) {
    if (getObservableParams !== undefined) {
        veloElement.onItemReady(opts.action(function ($item, itemData, index) {
            // for not all
            // item can return object with observable fields or just void
            var $bindItem = viewModelBindWrapper($item, opts);
            var itemCallResult = getObservableParams(itemData, $bindItem, index);
            if (itemCallResult) {
                var observeItem = viewModelBindAllWrapper($item, opts);
                observeItem(itemCallResult);
            }
        }));
    }
};
export var viewModelBindWrapper = function ($w, opts, parentAttrs) { return function (selector, attrSettings) {
    if (!attrSettings) {
        throw new Error("No selector found " + selector);
    }
    var veloElement = parentAttrs !== null && parentAttrs !== void 0 ? parentAttrs : $w(selector);
    var isRepeaterType = isRepeater(attrSettings);
    if (isRepeaterType) {
        observeRepeater(veloElement, attrSettings.item, opts);
    }
    var isMultiStateBoxType = isMultiStateBox(attrSettings);
    if (isMultiStateBoxType && attrSettings.currentState) {
        opts.reaction(attrSettings.currentState, function (data) {
            veloElement.changeState(data);
        });
    }
    var _loop_1 = function (attr, observableValue) {
        if (observableValue === undefined) {
            return "continue";
        }
        if (isRepeaterType && attr === 'item') {
            return "continue";
        }
        if (isMultiStateBoxType && attr === 'currentState') {
            return "continue";
        }
        if (isEventHandler(attr)) {
            // TODO: See if we detach it
            veloElement[attr](opts.action(observableValue));
            return "continue";
        }
        // Nested objects support
        if (isNestedAttributes(observableValue)) {
            var bindNestedField = viewModelBindWrapper($w, opts, observableValue);
            bindNestedField(selector, observableValue);
            return "continue";
        }
        if (attr) {
            opts.reaction(observableValue, function (data) {
                if (isImparative(attr)) {
                    var imperativeKey = getImperative(attr)[data ? 'on' : 'off'];
                    if (veloElement[imperativeKey]) {
                        veloElement[imperativeKey]();
                    }
                    else if (process.env.NODE_ENV === 'development') {
                        console.warn("Can't convert declarative to imperative field \"" + imperativeKey + "\" for " + selector + " element");
                    }
                }
                else {
                    veloElement[attr] = data;
                }
            }, {
                fireImmediately: true,
            });
        }
    };
    for (var _i = 0, _a = Object.entries(attrSettings); _i < _a.length; _i++) {
        var _b = _a[_i], attr = _b[0], observableValue = _b[1];
        _loop_1(attr, observableValue);
    }
}; };
export var viewModelBindAllWrapper = function ($w, opts) { return function (params) {
    var viewModelBind = viewModelBindWrapper($w, opts);
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], selector = _b[0], attrSettings = _b[1];
        if (!attrSettings) {
            continue;
        }
        viewModelBind(selector, attrSettings);
    }
}; };
//# sourceMappingURL=bind.js.map